export default {
  defense: {
    loadingTips: 'Loading.....',
    clientIP: 'Client IP',
    purchase: 'Purchase Anti-DDoS IP',
    off: 'OFF',
    on: 'ON',
    ipdetail: {
      selectRange: 'select a range',
      //blocking tab
      blockingtab: {
        labels: {
          domainName: 'Domain Name',
          blockTime: 'Block Time',
          blockDuration: 'Block Duration',
          type: 'Type',
          reason: 'Reason',
          actions: 'Actions'
        },
        batchUnblock: 'Unblock Blocked IP in Batches',

        blockedClientIp: 'Blocked Client IP',
        blockedClientIpTips: 'The blocked IP list is obtained by pulling the log records of the blocked IPs within the selected time range;<br />If the client IP has no access record, there will be no record even if it is blocked.',
        seconds: 'seconds',
        actionTips: 'If you unblock some IP successfully, the block record(s) will still exist, <br />but the client IP is already unblocked, please do not repeat the operation.',
        Unblock: 'Unblock',
        noDomainConfiguration: 'No domain configuration.',
        domainNotEnabled: 'Domain is not enabled.',
        sourceServerHealthCheckFailed: 'Failed to health check source server.',
        appTokenVerifyFailed: 'Failed to verify APP_TOKEN.',
        noAppToken: 'No APP_TOKEN.',
        blockedByBlacklist: 'Blocked by blacklist.',
        noAntiddosIpConfiguration: 'No Anti-DDos Ip configuration.',
        blockedForSpecialHttpRefererAttack: 'Blocked for special HTTP_REFERER attack.',
        headerError: 'Header Error.',
        triggeredCountryInterceptionRule: 'Triggered regional control (country interception rules).',
        triggeredProvinceInterceptionRule: 'Triggered regional control (province/state interception rules).',
        triggeredCityInterceptionRule: 'Triggered regional control (city interception rules).',
        triggeredPreciseAccessRefuse: 'Triggered precise access control blocking rules (Refuse Access).',
        triggeredPreciseAccessBlockIP: 'Triggered precise access control blocking rules (Block IP).',
        noSourcePort: 'No source port.',
        IPHasBeenBlocked: 'The IP has been blocked.',
        triggeredFrequencyLimit: "Too many visits by a single client: Triggered limit of ${times} time(s) in ${seconds} seconds",
        triggeredFrequencyQueriesLimit: 'Single client access is too fast: ',
        triggeredFrequencyInterceptionRule: 'Triggered frequency control interception: Triggered limit of ${times} time(s) in ${seconds} seconds',
        triggeredFrequencyBlockURIRule: 'Triggered frequency control to block URI: Triggered limit of ${times} time(s) in ${seconds} seconds',
        triggeredFrequencyBlockIPRule: 'Triggered frequency control to block IP: Triggered limit of ${times} time(s) in ${seconds} seconds',
        captchaIsRequiredMultipleTimes: 'CAPTCHA is required multiple times: ',



      },
      //cc attack tab
      ccatackTab: {
        labels: {
          attackTime: 'Attack Time',
          antiddosIP: 'Anti-DDoS IP',
          domainName: 'Domain Name',
        },


      },

      infoTab: {
        basicInfo: 'Basic Information',
        configInfo: 'Configuration Information',
        labels: {
          userId: 'User ID:',
          orderNo: 'Order No:',
          instance: 'Instance:',
          status: 'Status:',
          appToken: 'App Token:',
          creation: 'Creation Time:',
          expiration: 'Expiration Time:',
          line: 'Line :',
          defense: 'Defense:',
          bandwidth: 'Bandwidth:',
          qps: 'Business QPS:',
          domains: 'Protected Domains:',
          ports: 'Protected Ports:',
          regionalBlocking: 'Regional Blocking:',
          staticCaching: 'Static Page Caching:',
          preciseAccess: 'Precise Access:',
        },
        buttons: {
          generate: 'Generate',
          configuring: 'Configuring',
          update: 'Update',
        }

      },
      monitorTab: {
        labels: {
          minute: 'Minute',
          hour: 'Hour',
        },

      },


    },
    //AccelerationsRules
    acceleration: {
      customizeRules: 'Customize Rules',
      staticCacheList: 'Static Page Cache Acceleration Rules List：',

      ruleName: 'Rule Name',
      editRuleTitle: 'Edit Rule of Static Page Acceleration',
      addRuleTitle: 'Add Rule of Static Page Acceleration',
      deleteConfirm: 'Sure to delete the rule?',
      deleteRule: 'Delete Rule',
      warning: 'warning',
      labels: {
        uri: 'URI',
        standard: 'Standard',
        enhanced: 'Enhanced',
        noCache: 'No Cache',
        expiration: 'Expiration Time',
        default: 'Default',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        tenDays: '10 Days',
        thirtyDays: '30 Days',
        settingTime: 'Setting Time',
        actions: 'Actions',
        mode: 'Mode',
      },
      buttons: {
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        addRule: 'Add Rule',

      }
    },
    antiddos: {
      noDataTips1: 'No data found, you can',
      noDataTips2: 'create an instance',
      labels: {
        all: 'All',
        IP: 'IP',
        searchPlaceholder: 'IP',
        line: 'Line: ',
        bandwidth: 'Bandwidth (Mbps)',
        defense: 'Defense (Gbps)',
        domains: 'Protected Domains',
        ports: 'Protected Ports',
        qps: 'Business QPS',
        validityPeriod: 'Validity Period',
        charges: 'Price',
        status: 'Status',
        abnormal: 'Abnormal',
        normal: 'Normal',
        configChanging: 'Config Changing',
        configuring: 'Configuring',
        paused: 'Paused',
        actions: 'Actions',
      },
      buttons: {
        set: 'Set',
        renew: 'Renew',
        view: 'View',
        monitoring: 'Monitoring',
        changeConfiguration: 'Change Configuration',
      }

    },
    attackLog: {

      oneMinute: '1 Minute',
      fiveMinutes: '5 Minutes',
      thirtyMinutes: '30 Minutes',
      oneHour: '1 Hour',
      oneDay: '1 Day',
      labels: {
        domain: 'Domain',
        defenseIP: 'Defense IP',
        proxyHash: 'Proxy Hash',
        hashTips: 'Using different IPs in the same browser<br />\n' +
          '                will only generate a unique hash value.',
        ipUsingTheHash: 'IP using the hash',
        clientIPHashTips: 'The number of different client IPs using the same hash value\n' +
          '                <br />\n' +
          '                indicates how many proxy IPs are used by the same browser.',
        totalRequests: 'Total requests',
        attackRequests: 'Attack requests',
        actions: 'Actions',


      },
      buttons: {
        viewDetails: 'View Details',
      }
    },
    domainSetView: {
      log4SHell: 'Apache Log4Shell Remote Malicious Code Execution Vulnerability',
      inBlacklist: 'in Blacklist',
      inWhitelist: 'in Whitelist',
      current: 'Currently',
      customRules: 'Custom Rules Set',
      frequencyTips: 'Modes other than Normal will perform bot-identification, which needs to be turned on.',
      healthCheckTips: 'After the switch is turned off, the request will be backed to\n' +
        '            origin directly without health check.',
      labels: {
        domain: 'Domain：',
        vulnerabilityInterception: 'Vulnerability Interception',
        blacklistWhitelist: 'Blacklist / Whitelist for Domain Name',
        regionalBlocking: 'Regional Blocking for Domain Name',
        preciseAccess: 'Precise Access Control',
        frequency: 'Frequency Control',
        builtinMode: 'Built-in Mode',
        normal: 'Normal',
        urgent: 'Urgent',
        strict: 'Strict',
        superStrict: 'Super Strict',
        cacheMode: 'Cache Mode',
        staticCache: 'Static Page Cache Acceleration',
        mode: 'Mode:',
        strong: 'Strong',
        noCache: 'No Cache',
        all: 'ALL',
        warningNotice: 'Warning Notice',
        humanIdentify: 'Bot-Identification',
        jsVerify: 'JS Verification',
        slide: 'Slide',
        healthCheck: 'Health Check',
        appToken: 'APP Token',
        proxyAttack: 'Proxy Attack Control',
        observationMode: 'Observation Mode: Only records attack info in full log',
        interceptionMode: 'Interception Mode: Both records and intercept',
        loose: 'Loose',
        superLoose: 'Super Loose',
        cacheTime: 'Cache Time (s)',
        interceptionLevel: 'Interception Level',

      },
      buttons: {
        setBlacklist: 'Set Blacklist / Whitelist',
        setBlocking: 'Set Block Regions',
        customizeRules: 'Customize Rules',
        clearAllCache: 'Clear All Cache',
        refreshUriCache: 'Refresh Cache of Particular URI',
        save: 'Save',
        setWarningNotice: 'Set Warning Notice',
      }

    },
    layer4SetView: {

      labels: {
        set: 'Set：',
        regionalBlocking: 'Regional Blocking for the Rule',
        regionalBlockingTips: 'Please update the instance to activate this service first.',

      },
    },
    featuresLog: {

      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        domain: 'Domain',
        userAgent: 'User-Agent',
        totalRequests: 'Total requests',
        actions: 'Actions',

      },
      buttons: {
        addPreciseControl: 'Add Precise Control',
      }

    },
    frequencyRules: {
      deleteConfirm: 'Sure to delete the rule?',
      deleteRule: 'Delete Rule',
      warning: 'warning',
      labels: {
        frequencyRules: 'Frequency Control Rules of Domain：',
        ruleName: 'Rule Name',
        protectedURI: 'Protected URI',
        interval: 'Interval',
        singleIPVisits: 'Single IP Visits',
        matchingRule: 'Matching Rule',
        blockingType: 'Blocking Type',
        blockingTime: 'Blocking Time',
        actions: 'Actions',
      },
      buttons: {
        customizeRules: 'Customize Rules',
        addRule: 'Add Rule',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
      }

    },
    fullLog: {
      noIPSelected: 'No IP selected',
      ipNotExist: 'IP doesn\'t exist',
      qps: 'QPS',
      ccQPS: 'QPS of CC Attacks',
      totalQPS: 'Total QPS',
      defenseQPS: 'Defened QPS',
      labels: {
        accessTime: 'Access Time',
        domain: 'Domain Name',
        protocol: 'Protocol',
        url: 'URL',
        clientIP: 'Client IP',
        statusCode: 'Status Code',
        permission: 'Permission',
        humanIdentify: 'Human Identification',
        crawler: 'Crawler',
        actions: 'Actions',
        viewRawLog: 'View raw log',
      },

    },
    index: {
      labels: {
        ipCategory: 'Anti-DDoS IP',
        antiDdosIP: 'Instance',
        websiteProtection: 'Website Protection',
        nonWebProtection: 'Non-website Protection',
        accessLog: 'Access Log',
      },

    },
    indexLog: {
      labels: {
        accessLog: 'Access Log',
        fullLog: 'Full Log',
        visits: 'Visits',
        requestRegion: 'Request <br />\n' +
          '            Region Ranking',
        requestIP: 'Request IP<br />\n' +
          '            Ranking'
      },

    },
    ipSetView: {
      switchTips: 'Can be set for DDoS attack alerts, sudden overweight alerts, IP\n' +
        '          blocked alerts, etc.',
      labels: {
        set: 'Set:',
        setProtectionLevel: 'Set Protection Level',
        ipLevelAlerts: 'IP Level Alerts',
        levelAlertsSwitch: 'Level Alerts Switch',
      },
      buttons: {
        setAlertNotifications: 'Set Alert Notifications',
      }
    },
    ipView: {
      labels: {
        antiDdosIP: 'Anti-DDoS IP:',
        details: 'Details',
        monitoring: 'Monitoring',
        ipBlocking: 'IP Blocking',
        ccAttack: 'CC Attack',
      },
    },
    layerChart: {
      pps: 'Packages Per Second (pps)',
      qps: 'QPS',
      ccQPS: 'QPS of CC Attacks',
      conns: 'Current Connections (conns)',
      in: 'In',
      out: 'Out',
      average: 'Average',
      flowPerSecond: 'Flow Per Second (Mbps)',
      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        defenseIP: 'Defense IP',
      },
      buttons: {
        turnOnRealTime: 'Turn on real time',
      },
    },
    layerLog: {
      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        defenseIP: 'Defense IP',
        enterKeywordToSearch: 'Enter Keyword to Search',
        time: 'Time',
        clientIP: 'Client IP',
        portToForward: 'Port to forward',
        upstreamIP: 'Origin IP',
        portBackToUpstream: 'Port back to origin',
        protocol: 'Protocol',
        connections: 'Connections',
        outflow: 'Outflow',
        inflow: 'Inflow',
        requestTime: 'Request Time (s)',
      },

    },
    preciseRules: {
      deleteConfirm: 'Sure to delete the rule?',
      deleteRule: 'Delete Rule',
      warning: 'warning',
      labels: {
        customizeRules: 'Customize Rules',
        preciseAccessList: 'Precise Access Control List：',
        ruleName: 'Rule Name',
        and: 'AND',
        or: 'OR',
        ruleAction: 'Rule Action',
        refusal: 'Refusal',
        allow: 'Allow',
        challenge: 'challenge',
        expiration: 'Expiration',
        settingTime: 'Setting Time',
        actions: 'Actions',
        conditionalRelation: 'Conditional Relation',
        matchingCondition: 'Matching Condition',
      },
      buttons: {
        addRule: 'Add Rule',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
      }

    },
    rankLog: {
      selectDomain: 'Please select a Domain',
      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        selectIP: 'Please Select An IP',
        selectDomain: 'Please Select A Domain',
        requestIP: 'Requesting IP',
        defenseIP: 'Defense IP',
        totalRequests: 'Total Requests',
        normalRequests: 'Normal Requests',
        attackRequests: 'Attack Requests',
      }

    },
    refreshCache: {
      inputTips: 'Please enter the URL to be refreshed, multiple URLs are one per\n' +
        '                line,<br />\n' +
        '                and the format starts with http or https. Only GET requests are\n' +
        '                <br />\n' +
        '                supported, and the wrong format will be automatically\n' +
        '                ignored.<br />\n' +
        '                The refresh task takes about 5 minutes to take effect.<br />\n' +
        '                Go to Records for specific results.',
      invalidURIMsg: 'The number of valid URIs is 0, please check the format and content and resubmit',
      labels: {
        refreshURICache: 'Refresh Particular URI Cache:',
        url: 'URL',
        records: 'Records',
        action: 'Action',
        productType: 'Product Type',
        time: 'Time',
        status: 'Status',
      },
      buttons: {
        submitting: 'Submitting',
        submit: 'Submit',
      }

    },
    regionLog: {
      noIPSelected: 'No IP selected',
      ipNotExist: 'IP doesn\'t exist',
      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        selectIP: 'Please Select An IP',
        selectDomain: 'Please Select A Domain',
        time: 'Time',
        location: 'Location',
        defenseIP: 'Defense IP',
        domain: 'Domain',
        totalRequestIP: 'Total Number of Requesting IP',
        totalRequests: 'Total Requests',
        totalNormalRequestIP: 'Total Number of Normally Requesting IP',
        totalBlock: 'Total Number of Block IP'
      }

    },
    urlLog: {
      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        time: 'Time',
        domain: 'Domain',
        url: 'URL',
        totalRequestIP: 'Total Number of Requesting IP',
        totalRequests: 'Total Requests',
        actions: 'Actions',
      },
      buttons: {
        limitURL: 'Limit URL',
      }

    },
    visitsLog: {
      labels: {
        oneMinute: '1 Minute',
        fiveMinutes: '5 Minutes',
        thirtyMinutes: '30 Minutes',
        oneHour: '1 Hour',
        oneDay: '1 Day',
        selectIP: 'Please Select An IP',
        selectDomain: 'Please Select A Domain',
        totalRequestIP: 'Total Number of Requesting IP',
        totalRequests: 'Total Requests',
        totalNormalRequestIP: 'Total Number of Normally Requesting IP',
        totalBlock: 'Total Number of Block',
        defenseIP: 'Defense IP',
        domain: 'Domain Name',
        time: 'Time',
      }

    },
    website: {
      resolved: 'Resolved',
      unresolved: 'Unresolved',
      blacklist: 'blacklist',
      whitelist: 'whitelist',
      warning: 'warning',
      suspendConfirm: 'Sure to suspend the security protection?',
      startupConfirm: 'Sure to startup the security protection?',
      deleteProtectionConfirm: 'Sure to delete the security protection?',
      deleteCertificateConfirm: 'Sure to delete the certificate?',
      labels: {
        ddosIPOrDomain: 'Anti-DDoS IP/Domain Name',
        domainName: 'Domain Name',
        resolutionStatus: 'Resolution Status',
        serverIP: 'Server IP',
        ddosIP: 'Anti-DDoS IP',
        protocolType: 'Protocol Type',
        blackWhitelist: 'Blacklist / Whitelist',
        certificate: 'Certificate',
        noCertificate: 'No Certificate',
        toBeVerified: 'To be Verified',
        tlsSecurityPolicy: 'TLS Security Policy',
        pendingExpiration: 'Pending Expiration',
        expired: 'Expired',
        suspendProtection: 'Suspend Protection',
        startupProtection: 'Startup Protection',
        deleteProtection: 'Delete Protection',
        deleteCertificate: 'Delete Certificate',
        running: 'Running',
        configuring: 'Configuring',
        paused: 'Paused',
        creationTime: 'Creation Time',
        actions: 'Actions',
        status: 'Status',
        advanced: 'Advanced Functions',
      },
      buttons: {
        uploadCertificate: 'Upload Certificate',
        set: 'Set',
        suspend: 'Suspend',
        startup: 'Startup',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        modifyCertificate: 'Modify Certificate',
        deleteCertificate: 'Delete Certificate',
        addWebsite: 'Add Website',
        viewLog: 'View Log',
      }

    },
    nonWebsite: {
      warning: 'warning',
      suspendConfirm: 'Sure to suspend the forwarding rule?',
      startupConfirm: 'Sure to startup the forwarding rule?',
      batchDeleteConfirm: 'Sure to delete the ${len} select non-website protection rule?',
      deleteConfirm: 'Sure to delete this non-website protection rule?',
      labels: {
        originIPOrDomain: 'Origin Server IP/Domain Name',
        selectDdosIP: 'Select Anti-DDoS IP',
        forwardingProtocol: 'Forwarding Protocol',
        forwardingPort: 'Forwarding Port',
        originServerPort: 'Origin Server Port',
        forwardingMode: 'Back-to-origin Forwarding Mode',
        originServerIP: 'Origin Server IP',
        antiDdosPolicy: 'Anti-DDoS Policy',
        proxyProtocol: 'Proxy Protocol',
        ddosIP: 'Anti-DDoS IP',
        suspendTitle: 'Pause Rule',
        startupTitle: 'Startup Rule',
        deleteTitle: 'Delete Rule',
        running: 'Running',
        booting: 'Booting',
        configuring: 'Configuring',
        paused: 'Paused',
        creationTime: 'Creation Time',
        actions: 'Actions',
        status: 'Status',
        AddRule: 'Add Rule',
      },
      buttons: {
        set: 'Set',
        pause: 'Suspend',
        startup: 'Startup',
        edit: 'Edit',
        delete: 'Delete',
        batchDelete: 'Mass actions:',
        cancel: 'Cancel',
      }

    },
    components: {
      selectPayment: 'Please select a payment method',
      enterLoginPassword: 'Please enter the login password',
      createOrderFail: 'Create order fail!',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        ok: 'OK',
        done: 'Done',
        submit: 'Submit',
        submitting: 'Submitting',
        delete: 'Delete',
      },

      antDialog: {
        configuration: {

          invalidDomainNumber: 'Invalid Number,Domains should be at least ${minDomainNum}',
          invalidQPSNumber: 'Invalid Number,QPS should be at least ${minQpsNum}',
          invalidPortsNumber: 'Invalid Number,Ports should be at least ${minPortNum}',
          invalidBandwidthNumber: 'Invalid Number,Bandwidth number should between ${minBandwidth) and ${maxBandwidth)',
          invalidDomainsMultiple: 'Invalid Number,Domains should be multiple of ${domainInterval)',
          invalidQPSMultiple: 'Invalid Number,QPS should be multiple of ${qpsInterval)',
          invalidPortsMultiple: 'Invalid Number,Ports should be multiple of ${portInterval)',
          labels: {
            changeConfiguration: 'Change Configuration',
            defense: 'Defense:',
            targetBandwidth: 'Target Bandwidth:',
            protectedDomains: 'Protected Domains:',
            qps: 'QPS:',
            protectedPorts: 'Protected Ports:',
            regionalBlocking: 'Regional Blocking :',
            staticCaching: 'Static Page Caching :',
            preciseAccess: 'Precise Access Control :',
            charges: 'Price:',
          },


        },
        renew: {
          selectedInstance: '<span>${num}</span>instance selected',
          labels: {
            renew: 'Renew',
            duration: 'Duration : ',
            charges: 'Charges:',
            oneMonth: '1 Month',
            twoMonths: '2 Months',
            threeMonths: '3 Months',
            sixMonths: '6 Months',
            oneYear: '1 Year',
            twoYears: '2 Years',
            renewable: 'renewable',
            expiredAt: 'Expired at ${endTime}',
          }
        },
        set: {
          labels: {
            notificationSetting: 'IP Level Alert Notifications Setting',
            ddosAttack: 'DDoS Attack',
            remindEvery6min: 'Remind every 0.1 hour (6 minutes)',
            remindEvery: 'Remind every',
            hours: 'hours',
            excessiveBandwidth: 'Excessive Bandwidth',
            remindEvery5hours: 'Remind every 5 hours',
            ipBlocking: 'IP Blocking',
          }

        },
        unblockIP: {
          labels: {
            unblockClientIP: 'Unblock Client IP',
            ddosIP: 'Anti-DDoS IP:',
            blockedIP: 'Blocked IP :',
            suppertedIPTips: 'Multiple IPs supported,seperated by commas.',
          }
        }

      },
      logDialog: {
        statisticalPeriod: 'Statistical Period: December 30, 2021 11:10 ~ December 30, 2021\n' +
          '            11:12',
        labels: {
          sourceAreaDistribution: 'Analyze the Area: Source Area Distribution',
          region: 'Region',
          domain: 'Domain',
          time: 'Time',
          url: 'URL',
          clientIP: 'Client IP',
          defenseIP: 'Defense IP',
          totalRequests: 'Total requests',
          normalRequests: 'Normal requests',
          attackRequests: 'Attack requests',
          totalRequestingIP: 'Total number of requesting IP',
          totalBlockedIP: 'Total number of blocked IP',
        },
        analyzeArea: {
          sourceAreaDistribution: 'Analyze the Area: Source Area Distribution',


        },
        analyzeIP: {
          sourceIPDistribution: 'Analyze the Area: Source IP Distribution',

        },
        analyzeURL: {
          URIDistribution: 'Analyze the Area: URI Distribution',

        },
        analyzeVisits: {
          visits: 'Analyze the Area: Visits',

        },
        Attack: {

        },
        blockArea: {
          activateTips: 'To activate the function (or modify the regional ban rules),\n' +
            '              please go to (the "Settings" of the corresponding domain name on)\n' +
            '              the Website Protection page.',
          supportTips: 'Currently only supports blocking countries.',

          labels: {
            blockArea: 'Block Area',
            blockIP: 'Block IP :',
            blockDomain: 'Block Domain:',
            blockAreaColon: 'Block Area :',
          }

        },
        blockIP: {
          labels: {
            blockClientIP: 'Block Client IP',
            clientIP: 'Client IP :',
            oneIPOneLine: 'One ip one line',
            blockTime: 'Block Time :',
            fiveMinutes: '5 Minutes',
            tenMinutes: '10 Minutes',
            fifteenMinutes: '15 Minutes',
            thirtyMinutes: '30 Minutes'
          }

        },
        limitURL: {
          ruleCharacters: 'Composed of letters, numbers and underscore (_), no more than 128\n' +
            '              characters',
          uriTips: 'Filling in website domain name is not supported.<br />\n' +
            '              If you want to protect the URI request of the entire website,\n' +
            '              please fill in a character /, and select Prefix Matching as the\n' +
            '              matching rule.<br />\n' +
            '              If you want to protect the homepage of the website, please fill in\n' +
            '              a character /, and select Exact Matching as the matching rule.',
          exactMatchingTips: 'For example, if the URI is /, only the homepage can be\n' +
            '                    matched. If the URI is /a,<br />\n' +
            '                    it can only match /a, not /a/b, etc.',
          prefixMatchingTips: 'For example, if the URI is /, it can match the URI request\n' +
            '                    of the entire website.<br />\n' +
            '                    The URI is /a, which can match /a, /a/b, etc.',
          frequencyTips: 'If the request frequency of a certain client triggers a certain\n' +
            '              rule (for example, the URI is /a, and the matching rule is "Exact\n' +
            '              Match"), the next request of the client will be blocked\n' +
            '              accordingly.',


          labels: {
            editRule: 'Edit Rule of Frequency Control',
            ruleName: 'Rule Name:',
            url: 'URL:',
            mustStart: 'Must start with /',
            matchingRule: 'Matching Rule:',
            exactMatching: 'Exact Matching',
            prefixMatching: 'Prefix Matching',
            interval: 'Inspection Time:',
            second: 's',
            milliSecond: 'ms',
            times: 'times',
            singleIPVisits: 'Single IP Visits:',
            blockingType: 'Blocking Type:',
            refusal: 'Refusal: Discard the request which thus will not be backed to\n' +
              '                  origin',
            humanIdentification: 'Bot-Identification: Perform bot-identification on the request, which will be forwarded to the origin if it\'s passed by the identification.',
            uriBlocking: 'URI Blocking: Requests to the specified URl will be discarded during blocking time',
            ipBlocking: 'IP Blocking: Requests from the IP will be discarded during\n' +
              '                  blocking time',
          }

        },
        rawLog: {
          labels: {
            rawLog: 'Raw Log'
          }

        }

      },
      websiteDialog: {
        addWebsite: {
          ipSegmentWhitelistTips: 'Before adding a website, please ensure that the back-to-origin IP\n' +
            '          segment ( <span class="blue">${ipSegment}</span>\n' +
            '          ) has been added to your server whitelist / security group. If you\n' +
            '          have installed protection software (cloud lock, security dog, etc.),\n' +
            '          you also need to add the above source IP segment to the whitelist of\n' +
            '          the software, otherwise the anti-DDoS IP will be blocked and prevented\n' +
            '          from backing to origin, causing users to be unable to access.',
          domainResolutionTips: 'Anti-DDoS will automatically match the subdomain name\n' +
            '                  corresponding to the generic domain name. For example, if you\n' +
            '                  configure a *.text.com, you can match a.text.com, b.text.com,\n' +
            '                  www.text.com and other domain names at the same time. The\n' +
            '                  pan-domain name only occupies one configuration quota. If\n' +
            '                  there are both pan-domain and precise domain name\n' +
            '                  configurations (such as *.text.com and www.text.com), the\n' +
            '                  forwarding rules and protection policies configured by the\n' +
            '                  precise domain name will be used first.',
          loadBalanceTips: 'After configuring multiple (up to 10) origin IPs,\n' +
            '                      anti-DDoS instance forwards website access traffic to the\n' +
            '                      origin site in the form of IP Hash, and automatically\n' +
            '                      realizes the load balance of origin site.\n' +
            '                      <br />If your origin is an IIS server and you need to\n' +
            '                      use HTTPS, please make sure to turn on "Require Server\n' +
            '                      Name Indication".',
          httpCheckTips: 'By default: HTTP and HTTPS protocol requests each are backed to the origin with the corresponding protocol. If you check HTTP, HTTPS protocol requests will be backed to the origin using HTTP protocol.<br />' +
            'Note: If the origin site is configured with HTTP\n' +
            '                    redirection to HTTPS, please do not check this option,\n' +
            '                    otherwise the user\'s request will fall into endless\n' +
            '                    redirection.',
          httpsUpstreamTips: 'If you check HTTPS, the browser will be forced to access\n' +
            '                    using the HTTPS protocol, and the origin site does not\n' +
            '                    need to configure HTTP redirection to HTTPS.<br />\n' +
            '                    Note: If the origin site is configured with HTTPS\n' +
            '                    redirection to HTTP, please do not check this option,\n' +
            '                    otherwise the user\'s request will fall into endless\n' +
            '                    redirection.',
          protocolTips: 'If the website to be protected supports HTTPS encryption\n' +
            '                    authentication, you must check HTTPS.<br />\n' +
            '                    At the same time, you can check other protocol types\n' +
            '                    according to the protocol types actually supported by the\n' +
            '                    website.',
          noInstanceTips: 'There are no available instances or they have all been suspended. Please check whether they have expired and renew in time.',
          selectInstance: 'Please select an instance',
          labels: {
            addWebsite: 'Add Website',
            package: 'Package:',
            standard: 'Standard',
            instance: 'Instance:',
            domain: 'Domain Name:',
            protocolType: 'Protocol Type:',
            serverAddress: 'Server Address:',
            upstreamIP: 'Origin IP',
            upstreamDomain: 'Origin Domain Name',
            serverPort: 'Server Port:',
            originIPOrDomainTips: 'Origin IP: up to 10, separated by commas and cannot be repeated. Origion Domain Name: support one only.',
            forcedBackToUpstream: 'Forced Back to Origin',
            mandatoryAccess: 'Forced Access',
            appToken: 'App Token:',
          }

        },
        blockRegions: {
          labels: {
            blockRegions: 'Block Regions',
            checkAll: 'Check All',
            reverse: 'Reverse',
            checkAllCountries: 'Check All Countries',
          }

        },
        editAccelerationRules: {
          ruleCharacters: 'Composed of letters, numbers and underscore (_), no more than 128\n' +
            '              characters',

          labels: {
            ruleName: "Rule Name:",
            url: "URI:",
            mustStartWith: "Must start with /",
            cacheMode: "Cache Mode:",
            standard: "Standard",
            standardTips: "Automatically cache static resource files such as js and\n" +
              "                    css",
            enhanced: "Enhanced",
            enhancedTips: "Attempt to cache the requested URI resource.",
            noCache: "No Cache",
            noCacheTips: "The requested URI resource wil not be cached.",
            matchingRule: "Matching Rule:",
            exactMatching: "Exact Matching",
            exactMatchingTips: "Only call if the requested URI is exactly the same as the\n" +
              "                    filled URI.",
            prefixMatching: "Prefix Matching",
            prefixMatchingTips: "Call when the requested URI matches the filled URI",
            requestType: "Request Type:",
            expirationTime: "Expiration Time:",
          }

        },
        editCertificate: {
          certExample: 'Format Sample:\r\n-----BEGIN CERTIFICATE-----\r\n******************************\r\n-----END CERTIFICATE-----',
          privateKeyExample: 'Format Sample:\r\n-----BEGIN PRIVATE KEY-----\r\n******************************\r\n-----END PRIVATE KEY-----\r\nOr:\r\n-----BEGIN RSA PRIVATE KEY-----\r\n**********************************\r\n-----END RSA PRIVATE KEY-----',
          labels: {
            editCertificate: 'Edit Certificate',
            serverIP: 'Server IP:',
            manualUpload: 'Manual Upload',
            domainName: 'Domain Name:',
            certificateName: 'Certificate Name:',
            certCharacters: 'Only supports letters, numbers, underscores, and hyphens.',
            certFile: 'Certificate File',
            certTips: 'For certificates in .pem, .cer, and .crt formats, you can\n' +
              '                    use a text editor to directly open the certificate file and\n' +
              '                    copy the text content. For certificates in other formats\n' +
              '                    (such as .pfx, .p7b, etc.), you need to convert the\n' +
              '                    certificate file to .pem format before that.',
            secretKey: 'Secret Key:',
            enterCertName: 'Please enter a certificate name',
          }

        },
        editFrequencyRules: {
          labels: {
            editRule: 'Add/Edit Rule of Frequency Control',
            ruleName: 'Rule Name:',
            ruleCharacters: 'Composed of letters, numbers and underscore (_), no more than 128\n' +
              '              characters',
            uri: 'URI:',
            mustStartWith: 'Must start with /',
            matchingTips: 'Filling in website domain name is not supported.<br />\n' +
              '              If you want to protect the URI request of the entire website,\n' +
              '              please fill in a character /, and select Prefix Matching as the\n' +
              '              matching rule.<br />\n' +
              '              If you want to protect the homepage of the website, please fill in\n' +
              '              a character /, and select Exact Matching as the matching rule.',
            matchingRule: 'Matching Rule:',
            exactMatching: 'Exact Matching',
            exactMatchingTips: 'For example, if the URI is /, only the homepage can be\n' +
              '                    matched. If the URI is /a,<br />\n' +
              '                    it can only match /a, not /a/b, etc.',
            prefixMatching: 'Prefix Matching',
            prefixMatchingTips: 'For example, if the URI is /, it can match the URI request\n' +
              '                    of the entire website.<br />\n' +
              '                    The URI is /a, which can match /a, /a/b, etc.',
            interval: 'Interval:',
            second: 's',
            millisecond: 'ms',
            singleIPVisits: 'Single IP Visits:',
            times: 'times',
            blockingType: 'Blocking Type:',
            refusal: 'Refusal: Discard the request which thus will not be backed to\n' +
              '                  origin',
            humanIdentification: 'Human Identification: Only forward to origin if verification\n' +
              '                  is passed',
            uriBlocking: 'URI Blocking: Requests to the specified URl will be discarded during blocking time',
            ipBlocking: 'IP Blocking: Requests from the IP will be discarded during\n' +
              '                  blocking time',
            blockedTips: 'If the request frequency of a certain client triggers a certain\n' +
              '              rule (for example, the URI is /a, and the matching rule is "Exact\n' +
              '              Match"), the next request of the client will be blocked\n' +
              '              accordingly.',
            integerFrom1to1440: 'Enter an integer from 1 to 1440',
            minute: 'minute',
            banDuration: 'Ban Duration:Enter an integer from 1 to 1440.',
          }

        },
        editPreciseRules: {
          labels: {
            editRule: 'Add/Edit Precise Access Control Rule',
            ruleName: 'Rule Name:',
            ruleCharacters: 'Composed of letters, numbers and underscore (_), no more than 128\n' +
              '              characters',
            conditionalRelation: 'Conditional Relation:',
            and: 'AND',
            or: 'OR',
            matchingCondition: 'Matching Condition:',
            matchingField: 'Matching Field',
            logicalSymbol: 'Logical Symbol',
            matchingContent: 'Matching Content (Case-sensitive)',
            matchingTips: 'Currently does not support regular expression\n' +
              '                          description, but is allowed to be set to a null\n' +
              '                          value.<br />\n' +
              '\n' +
              '                          Supports adding multiple matching conditions. If so,\n' +
              '                          it will only hit when the access request meets all\n' +
              '                          conditions.',
            actions: 'Actions',
            AddALine: 'Add a line',
            ruleAction: 'Rule Action:',
            expiration: 'Expiration:',
          }

        },
        editWebsite: {
          ipSegmentWhitelistTips: 'Before adding a website, please ensure that the back-to-origin IP\n' +
            '          segment ( <span class="blue">${ipSegment}</span>\n' +
            '          ) has been added to your server whitelist / security group. If you\n' +
            '          have installed protection software (cloud lock, security dog, etc.),\n' +
            '          you also need to add the above source IP segment to the whitelist of\n' +
            '          the software, otherwise the anti-DDoS IP will be blocked and prevented\n' +
            '          from backing to origin, causing users to be unable to access.',
          domainResolutionTips: 'Anti-DDoS will automatically match the subdomain name\n' +
            '                  corresponding to the generic domain name. For example, if you\n' +
            '                  configure a *.text.com, you can match a.text.com, b.text.com,\n' +
            '                  www.text.com and other domain names at the same time. The\n' +
            '                  pan-domain name only occupies one configuration quota. If\n' +
            '                  there are both pan-domain and precise domain name\n' +
            '                  configurations (such as *.text.com and www.text.com), the\n' +
            '                  forwarding rules and protection policies configured by the\n' +
            '                  precise domain name will be used first.',
          httpCheckTips: 'By default: HTTP and HTTPS protocol requests each are backed to the origin with the corresponding protocol. If you check HTTP, HTTPS protocol requests will be backed to the origin using HTTP protocol.<br />\n' +
            'Note: If the origin site is configured with HTTP redirection to HTTPS, please do not check this option, otherwise the user\'s request will fall into endless redirection.',
          loadBalanceTips: 'After configuring multiple (up to 10) origin IPs,\n' +
            '                      anti-DDoS instance forwards website access traffic to the\n' +
            '                      origin site in the form of IP Hash, and automatically\n' +
            '                      realizes the load balance of origin site.\n' +
            '                      <br />If your origin is an IIS server and you need to\n' +
            '                      use HTTPS, please make sure to turn on "Require Server\n' +
            '                      Name Indication".',
          httpsUpstreamTips: 'If you check HTTPS, the browser will be forced to access\n' +
            '                    using the HTTPS protocol, and the origin site does not\n' +
            '                    need to configure HTTP redirection to HTTPS.<br />\n' +
            '                    Note: If the origin site is configured with HTTPS\n' +
            '                    redirection to HTTP, please do not check this option,\n' +
            '                    otherwise the user\'s request will fall into endless\n' +
            '                    redirection.',
          protocolTips: 'If the website to be protected supports HTTPS encryption\n' +
            '                    authentication, you must check HTTPS.<br />\n' +
            '                    At the same time, you can check other protocol types\n' +
            '                    according to the protocol types actually supported by the\n' +
            '                    website.',
          labels: {
            editWebsite: 'Edit Website',
            package: 'Package:',
            standard: 'Standard',
            instance: 'Instance:',
            domain: 'Domain Name:',
            protocolType: 'Protocol Type:',
            serverAddress: 'Server Address:',
            upstreamIP: 'Origin IP',
            upstreamDomain: 'Origin Domain',
            originIPOrDomainTips: 'Origin IP: up to 10, separated by commas and cannot be repeated. Origin Domain Name: support one only.',
            serverPort: 'Server Port:',
            forcedBackToUpstream: 'Forced Back to Origin',
            mandatoryAccess: 'Forced Access',
            appToken: 'App Token:',
            selectInstance: 'Please select an instance',
          }

        },
        purchaseRules: {
          labels: {
            purchaseQuantityRules: 'Purchase Quantity of Rules',
            currentQuantityRulesAvailable: 'Current quantity of rules available: 10',
            newRulesQuantity: 'Quantity of New Rules: ',
            charges: 'Charges: ',
          }

        },
        setBlacklist: {
          supportFormat: 'Supports filling in IP or IP/mask format.<br />\n' +
            '          Up to 200 non-duplicate items can be added to the blacklist or\n' +
            '          whitelist, separated by commas. The blacklist supports\n' +
            '          adding 0.0.0.0/0, which means to block access requests from all IPs\n' +
            '          except the normal IP configured in the whitelist.<br />\n' +
            '          In some cases, it may take some access traffic and time before the\n' +
            '          blacklist or whitelist (for domains) setting takes effect. If the\n' +
            '          setting does not take effect immediately after the blacklist /\n' +
            '          whitelist (for domains) is enabled, please try to continue to access\n' +
            '          the domain name several times.',
          labels: {
            setBlacklistWhitelist: 'Set Blacklist / Whitelist for Domain Name',
            blacklist: 'Blacklist',
            whitelist: 'Whitelist',
            enterContent: 'Please enter content',
          }

        },
        setNotice: {
          labels: {
            setWarningNotice: 'Set Warning Notice',
            remindEvery: 'Remind every',
            hours: 'hours',
          }

        },
        setToken: {
          exceptionTips: 'Supports up to 100 non-duplicated items in exception links, separated\n' +
            '          by commas (,), no domain name is required, and parameters are not\n' +
            '          supported (parameters will be ignored directly).<br />\n' +
            '\n' +
            '          Caution: links above will no longer be verified by APP Token after\n' +
            '          setting.',
          labels: {
            setTokenExceptionUrl: 'Set Token Exception URL',
          }

        }

      },
      nonDialog: {
        addRule: {
          forwardingPortRange: 'Range 1-64999, excluding 80, 443, 8080, 843, 53, 22 and 10050',
          originPortRange: 'Range 1-64999',
          originServerIPLimit: 'You can specify up to 20 origin server IP addresses. Separate multiple IP addresses with commas (,).',
          proxyProtocolTips: 'To retrieve actual IP addresses of clients, please select this option.\n' +
            '                    The origin server must also support PROXY Protocol.',
          labels: {
            AddRule: 'Add Rule',
            WheelMode: 'Back-to-origin Forwarding Mode',
            Instance: 'Instance',
            ForwardingProtocolWithColon: 'Forwarding Protocol',
            forwardingPort: 'Forwarding Port',
            originServerPort: 'Origin Server Port',
            LSVForwardingRules: 'LSV Forwarding rules',
            OriginServerIP: 'Origin Server IP',
            MatchingRule: "Clients Actual IP Option",
            ProxyProtocol: 'Proxy Protocol',
            ForwardProtocol: 'Forward protocol',
          },
        },
      },
    },
    titles: {
      antiDdosIP: 'Anti-DDoS IP',
      web: 'IP Website Protection',
      fullLog: 'IP Full Log',
      ipVisits: 'IP Visits',
      ipRegionRanking: 'IP Region Ranking',
      ipRanking: 'IP Ranking',
      //以下暂无页面
      urlLog: 'URL',
      featuresLog: 'Features',
      layerLog: 'Layer',
      layerChart: 'Layer Chart',
      attackLog: 'Attack',

      // ipSetting: 'Anti-DDoS IP Setting',
      // webSetting: 'IP Website Protection Setting',
    },
    util: {
      Failed: 'Failed',
      NotTriggered: 'Not triggered',
      WatchAccess: 'Watch Access',
      Abnormal: 'Abnormal',
      Access: 'Access',
      AITriggered: 'AI triggered',
      Blocked: 'Blocked',
      RulesBlocked: 'Rules Blocked',
    }





  }

}



// WEBPACK FOOTER //
// ./src/lang/en/defense.js